// extracted by mini-css-extract-plugin
module.exports = {"input":"RestrictedInput_input__23kOB"};